import { ErrorInfo, ErrorCode } from "@/network/http";
import { requestData } from "./base";
import { nullPageInfo } from "@/data/local/base";
import { 
    GetArchivesListReq, 
    GetArchivesListRsp
} from '@/data/remote/archives'
import { ArchivesList } from '@/data/local/archives'

const URL_GET_ARCHIVES_LIST = "/common/archives/getArchivesList";//获取文库列表

export const getArchivesList = (subCat: number, pageNo: number, pageSize: number, callback?: (errorInfo: ErrorInfo, data: ArchivesList) => void) => {
    const payload: GetArchivesListReq = {
        subCat,
        pageNo,
        pageSize
    };

    requestData(URL_GET_ARCHIVES_LIST, payload, (errorInfo: ErrorInfo, data: GetArchivesListRsp) => {
        let rspData: ArchivesList = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {
            list: [...data.list],
            pagination: {
                pageNo: data.pageNo,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                totalPage: data.totalPage
            }
        } : nullPageInfo;
        callback && callback(errorInfo, rspData);
    });
}
